export default __webpack_public_path__ + "static/media/090-flats.7b2bb24d.svg";